import { UrlSerializer, DefaultUrlSerializer, UrlTree } from '@angular/router';

export class CaseInsensitiveUrlSerializer implements UrlSerializer {
  parse(url: string): UrlTree {
    // Check if the URL contains '/sustainability' (case-insensitive)
    if (url.toLowerCase().includes('/sustainability')) {
      // Convert the URL to lowercase before parsing
      const lowerCaseUrl = url.toLowerCase();
      return new DefaultUrlSerializer().parse(lowerCaseUrl);
    }
    // Use the default behavior for other URLs
    return new DefaultUrlSerializer().parse(url);
  }

  serialize(tree: UrlTree): string {
    // Serialize the UrlTree
    const serializedUrl = new DefaultUrlSerializer().serialize(tree);

    // Check if the serialized URL contains '/sustainability' (case-insensitive)
    if (serializedUrl.toLowerCase().includes('/sustainability')) {
      // Convert the URL to lowercase
      return serializedUrl.toLowerCase();
    }
    // Use the default behavior for other URLs
    return serializedUrl;
  }
}
